<template>
  <div class="ProductDetail_wrapper">
    <img :src="ext.productPicTop" class="banner_img" />
    <div class="insurance-info common_for_pc">
      <div class="left">
        <div class="type">{{ productData.productName }}</div>
        <div class="invest">{{ productData.productIntro }}</div>
      </div>
      <div class="right">
        <div class="pingan">{{ productData.comment }}</div>
        <div class="deadline">{{ productData.productIntroIn }}</div>
      </div>
    </div>

    <div class="split"></div>

    <div class="insurance_plan common_for_pc">
      <div class="plan">
        <div class="program">保障方案</div>
        <div class="detail" @click="goInnerDetail">保障详情</div>
      </div>
      <div class="plan_nav">
        <div
          :class="`nav_item ${currentCase === index ? 'current' : ''}`"
          v-for="(item, index) in productCases"
          :key="item.id"
          @click="handleCaseChange(index)"
        >
          {{ item.propertyName }}
        </div>
      </div>
      <!-- <div class="plan">
<div class="program">保障方案</div>
<div class="detail">保障详情</div>
      </div>-->
      <div class="plan_details">
        <p v-for="(item, index) in liabilitys" :key="index">
          <span>{{ item.title }}</span>
          <span>{{ item.amount }}</span>
        </p>
      </div>
    </div>

    <div class="price-container common_for_pc">
      <span class="price">保费</span>
      <span class="num">{{ propertyPremium }}</span>
    </div>

    <div class="more_detail common_for_pc">
      更多详情请阅读
      <span @click="goDeclaration">《投保须知及声明》</span>和
      <span @click="handlePDF">《条款详情》</span>
    </div>
    <!-- pdf弹出框 -->
    <van-action-sheet v-model="show" title="投保须知及声明" class="action_box">
      <div class="pdf_box">
        <div class="pdf_content"></div>
      </div>
    </van-action-sheet>
    <div class="split"></div>

    <div class="detail_nav common_for_pc" ref="detailNav">
      <div :class="`detail_nav_box ${isfixed ? 'fixed' : ''}`">
        <div
          v-for="item in detailNavList"
          :key="item.id"
          :class="`detail_nav_item ${currentNav === item.id ? 'active' : ''}`"
          @click="handleNavClick(item.id)"
        >
          {{ item.msg }}
        </div>
      </div>
    </div>
    <div class="detail_box common_for_pc">
      <div class="module" ref="module1">
        <img :src="ext.productFeatures" alt @load="handleLoad(1)" />
      </div>
      <div class="module" ref="module2">
        <img :src="ext.productClaim" alt @load="handleLoad(2)" />
      </div>
      <div class="module" ref="module3">
        <img :src="ext.productQuestions" alt @load="handleLoad(3)" />
      </div>
    </div>
    <div class="footerBtn common_for_pc">
      <div class="one" @click="goHome">
        <span class="icon1 icon-home iconfont"></span>
        <span class="index">首页</span>
      </div>
      <div @click="showKeFuFlag = true">
        <span class="icon2 icon-kefu iconfont"></span>
        <span>客服</span>
      </div>
      <div>{{ propertyPremium }}元</div>
      <div @click="jumpPolicyForm">立即投保</div>
    </div>
    <!-- 客服弹出框 -->
    <van-popup v-model="showKeFuFlag" position="bottom" class="kefuPop">
      <div class="kefu_h">
        <a class="kefu_con" href="tel:400-099-6778">
          <span class="kefu_pic"></span>电话咨询
        </a>
      </div>
	  <div class="kefu_h_for_pc">
	    请拨打400-099-6778进行电话联系
	  </div>
      <div class="kefu_b" @click="showKeFuFlag = false">取消</div>
    </van-popup>
	<IFrameModal :url="url" v-show="showIFrameModal" v-on:closeiframe="closeiframe"/>
  </div>
</template>

<script>
import './ProductDetail.less'
import { ActionSheet, Popup,Toast } from 'vant'
// 引入pdf插件
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
import { getProductDetail } from '../../api/api'
import IFrameModal from "@/components/IFrameModal.vue";
export default {
  name: 'ProductDetail',
  data() {
    return {
	  "hardCodeLiabilitys": [{
			"title": "家政人员-身故及残疾",
			"amount": "40万",
		}, {
			"title": "家政人员-医疗费用（免赔100元）",
			"amount": "4万",
		}, {
			"title": "家政人员-误工费（免赔5天）",
			"amount": "200元/天",
		}, {
			"title": "家政人员-每日住院津贴",
			"amount": "150元/天",
		}, {
			"title": "家政人员-救护车津贴",
			"amount": "300元/次",
		}, {
			"title": "第三者责任-赔偿限额",
			"amount": "400万",
		}, {
			"title": "第三者责任-身故及伤残",
			"amount": "20万",
		}, {
			"title": "第三者责任-医疗费用（免赔100元）",
			"amount": "4万",
		}, {
			"title": "第三者责任-财产损失（免赔300元）",
			"amount": "4万",
		}, {
			"title": "其他责任-法律费用",
			"amount": "20万",
		}, {
			"title": "其他责任-突发急性病身故",
			"amount": "15万",
		}],
	  showIFrameModal:false,
	  url:'',
      showKeFuFlag: false, // 展示客服
      fixedHeight: 0,
      offsetHeight: 0,
      isfixed: false,
      currentNav: 1,
      currentCase: 0,
      show: false,
      pdfh5: null,
      offectTopModule1: null,
      offectTopModule2: null,
      offectTopModule3: null,
      imgLoad: [],
      productCases: [],
      detailNavList: [
        {
          id: 1,
          msg: '产品特色',
        },
        {
          id: 2,
          msg: '理赔说明',
        },
        {
          id: 3,
          msg: '常见问题',
        },
      ],
      productData: {},
      ext: {},
      propertyPremium: '￥0',
      liabilitys: [],
    }
  },
  components: {
    'van-action-sheet': ActionSheet,
    'van-popup': Popup,
	IFrameModal,
  },
  mounted() {
	  Toast.loading({
	    message: '加载中',
	    forbidClick: true,
	    duration: 0,
	    loadingType: 'spinner'
	  })
    this.getProductDetail()
    window.addEventListener('scroll', this.handleScroll)
	Toast.clear()
  },
  methods: {
	closeiframe:function(){
	  this.showIFrameModal = !this.showIFrameModal;
	},
    goDeclaration() {
		this.showIFrameModal = true
		this.url = window.location.origin + '/PolicyDeclaration?productId=' + this.$route.query.productId
      // this.$router.push({
      //   path: '/PolicyDeclaration',
      //   query: { productId: this.$route.query.productId },
      // })
    },
    async getProductDetail() {
      const { productId } = this.$route.query
      const data = await getProductDetail({
        pid: productId,
      })
      console.log(data)
      this.productData = data.product
      this.ext = data.product.ext || {}
      this.productCases = data.product.insurances[0].insuranceAmount
	  if(productId == 157){
		  if(this.productCases[3] && this.productCases[3]['liabilitys'].length == 0){
			  this.productCases[3]['liabilitys'] = this.hardCodeLiabilitys
		  }
	  }
      this.propertyPremium =
        data.product.insurances[0].insuranceAmount[0].propertyPremium
      this.liabilitys =
        data.product.insurances[0].insuranceAmount[0].liabilitys
    },
    // 图片加载完毕
    handleLoad(index) {
      this.imgLoad.push(index)
      if (this.imgLoad.length === 3) {
        this.$nextTick(() => {
          this.fixedHeight = this.$refs.detailNav.offsetTop
          this.offsetHeight = this.$refs.detailNav.offsetHeight
          this.offectTopModule1 = this.$refs.module1.offsetTop
          this.offectTopModule2 = this.$refs.module2.offsetTop
          this.offectTopModule3 = this.$refs.module3.offsetTop
        })
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop
      this.isfixed = scrollTop > this.fixedHeight
      if (scrollTop >= this.offectTopModule2 - this.offsetHeight) {
        this.currentNav = 2
      } else if (scrollTop >= this.offectTopModule3 - this.offsetHeight) {
        this.currentNav = 3
      } else {
        this.currentNav = 1
      }
    },
    handleCaseChange(index) {
      this.currentCase = index
      this.propertyPremium = this.productData.insurances[0].insuranceAmount[
        index
      ].propertyPremium
      this.liabilitys = this.productData.insurances[0].insuranceAmount[
        index
      ].liabilitys
    },
    handleNavClick(id) {
      this.currentNav = id
      this.$nextTick(() => {
        if (id === 1) {
          document.documentElement.scrollTo(
            0,
            this.offectTopModule1 - this.offsetHeight
          )
        }
        if (id === 2) {
          document.documentElement.scrollTo(
            0,
            this.offectTopModule2 - this.offsetHeight
          )
        }
        if (id === 3) {
          document.documentElement.scrollTo(
            0,
            this.offectTopModule3 - this.offsetHeight
          )
        }
      })
    },
    // 展示pdf
    handlePDF() {
      // const { productId } = this.$route.query
	  this.showIFrameModal = true
	  this.url = window.location.origin + '/termsDetail?pid=' + this.$route.query.productId
      // console.log(productId)
      // 跳转条款详情
      // this.$router.push({
      //   path: '/termsDetail',
      //   query: {
      //     pid: productId
      //   }
      // })
    },
    jumpPolicyForm() {
	  Toast.loading({
	    message: '加载中',
	    forbidClick: true,
	    duration: 0,
	    loadingType: 'spinner'
	  })
      const { productData, ext } = this.$data
      const params = {
		// currentCase: this.productCases[this.currentCase],
        product: productData,
        pid: productData.id,
        appkey: 'dsbjk',
        policy: {
          productRisk: ext.productRisk, //协议
          proname: productData.productName,
          total: productData.lfee,
          deliveryType: 0,
          productId: productData.id,
          clauses: ext.clauses,
        },
        products: [
          {
            insuranceId: productData.insurances[0].id,
            amount:
              productData.insurances[0].insuranceAmount
                .propertyValue,
            copys: 1,
            payterm:
              productData.insurances[0].payPeriod.propertyValue,
            insuranceterm:
              productData.insurances[0].insurancePeriod
                .propertyValue,
          },
        ],
        productStartTime: ext.productStartTime,
      }
      localStorage.setItem('productInfo', JSON.stringify(params))
      this.$router.push({
        path: '/infoForm',
        query: {
          productId: this.productData.id,
		  ...this.$route.query
        },
      })
    },
    // 跳转保障详情
    goInnerDetail() {
		this.showIFrameModal = true
		this.url = window.location.origin + '/InnerPolicyDetail?productId=' + this.productData.id
      // this.$router.push({
      //   path: './InnerPolicyDetail',
      //   query: {
      //     productId: this.productData.id
      //   }
      // })
    },
    // 跳转首页
    goHome() {
      this.$router.push('./Home')
    },
  },
}
</script>

